/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useContext } from "react";

import { FooterContext } from "src/context/footerContext";
import {AuthContext} from "../../context/authContext";

import { FAX_NUMBER, PHONE_NUMBER } from "../../constants/contact";
import { ContactAndSafetyInfoProps } from "./types";




const ContactAndSafetyInfo: FC<ContactAndSafetyInfoProps> = ({ alignText, textColor, isLogin = false }): JSX.Element => {
  const { isUserAuthorized } = useContext(AuthContext);
  const { changeAccordianVisibility } = useContext(FooterContext)

  return (
    <>
      <div className={`${alignText} align-items-center`}>
        <button
          type="button" onClick={changeAccordianVisibility}
          className={`btn btn-link p-0${!isUserAuthorized ? " text-black fw-bold border-0" : ""}`}
        >
          Important Safety Information
        </button>
        <span className={`text-${textColor}`}> | </span>
        <a
          href="https://www.furoscix.com/wp-content/uploads/prescribing-information.pdf" target="_blank"
          className={isUserAuthorized ? "btn btn-link p-0" : "text-black fw-bold"} rel="noreferrer"
        >
          Full Prescribing Information
        </a>
      </div>

      <div className={`${alignText} mb-3`} data-tour="sixth-step">
        <p>Liaisons Contact: 516-620-4938 | Phone: {PHONE_NUMBER} | Fax: {FAX_NUMBER}</p>
      </div>
    </>
  );
};

export default ContactAndSafetyInfo;
